module.exports = __webpack_public_path__ + "img/face-rolling-eyes.2d7f5526.svg";